/**
 * Composition method for EPIC HR App content
 * 
 * Author: Andrea López
 */
 import { computed } from 'vue';
 import { useStore } from 'vuex';

export function epicContentComposition () {
    const store = useStore();

    // Screen computed
    const screen = computed((): string => store.getters.get_ehrScreen);

    // function navigate to screen
    function switchScreen (screenTo: string) {
        store.dispatch('axn_updateEhrScreen', screenTo);
    }

    // External links
    const links = [
        {
            id: 'fact-sheet-healthcare-providers',
            url: 'https://www.fda.gov/media/155050/download'
        },
        {
            id: 'fact-sheet-patients-parents-caregivers',
            url: 'https://www.fda.gov/media/155051/download'
        },
        {
            id: 'fda-emergency-letter',
            url: 'https://www.fda.gov/media/155049/download'
        }
    ]

    // Navigate to external link
    function navigateTo (link) {
        window.open(link);
    }

    return { screen, switchScreen, links, navigateTo }
}

export function epicSidebarComposition () {
    const store = useStore();
    const toggleDisplay = computed((): boolean => store.getters.get_ehrSidebarActive);

    const toggleTimeline = () => {
        store.dispatch('axn_updateEhrSidebarActive');
    }

    return { toggleDisplay, toggleTimeline }
}
